export default __webpack_public_path__ + "static/avocat-man-dca2abfa6bf1c989feccb21457ab43df.png";